import { building } from '$app/environment';
import { i18n } from '$lib/i18n';

export const reroute = !building && i18n.reroute();
